export default __webpack_public_path__ + "static/media/hero-image.e12fbcc9.png";